export default __webpack_public_path__ + "static/media/p1_main.0ccc92f8.png";